import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { IdDescription } from 'tms-lib';
import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class ProcessReferenceService extends BaseReferenceService {
  constructor() {
    super('ProcessReference');
  }

  // A route belongs to one production process, so only that process's steps are offered.
  getForProductionProcess(productionProcessId: string): Observable<IdDescription[]> {
    return this.httpService.get<IdDescription[]>(`${this.apiUrl}/ProductionProcess/${productionProcessId}`);
  }
}
